export type EmpfaengerStatus = 'offen' | 'sending' | 'gesendet' | 'fehler';

export interface Bilanz {
  gesamt: number;
  gesendet: number;
  fehler: number;
  /** offen UND sending — beides ist „noch nicht durch". */
  offen: number;
  fertig: boolean;
}

/**
 * Die eine Stelle, an der aus Empfaengerzeilen Zahlen werden — Uebersicht,
 * Detailseite und Fortschrittsbalken lesen alle hier, damit sie nicht
 * auseinanderlaufen.
 *
 * Ein Lauf gilt als fertig, sobald nichts mehr offen ist. Fehler machen ihn NICHT
 * unfertig: sonst haengt ein Lauf mit einer kaputten Adresse fuer immer.
 */
export function baueBilanz(zeilen: { status: EmpfaengerStatus }[]): Bilanz {
  const liste = zeilen || [];
  const gesendet = liste.filter((z) => z.status === 'gesendet').length;
  const fehler = liste.filter((z) => z.status === 'fehler').length;
  const offen = liste.filter((z) => z.status === 'offen' || z.status === 'sending').length;
  return { gesamt: liste.length, gesendet, fehler, offen, fertig: liste.length > 0 && offen === 0 };
}
